import { Link } from 'react-router-dom'
import { Text, FlexBox, Button } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { routes as marketingRoutes } from 'app/marketing/routes'
import blockBackground from 'assets/images/graphics/fable-hero-clouds-mobile-pink.webp'

const ClubDetailPrivateClubBlock = () => {
  const { colors } = useTheme()

  return (
    <FlexBox
      centerAll
      className={css`
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: ${colors.uiPearlExtraLight};
      `}
    >
      <FlexBox
        flexDirection="column"
        centerAll
        gap="50px"
        className={css`
          position: relative;
          background-color: ${colors.uiWhite};
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          padding: 20px;
          width: 320px;
          height: 320px;
          text-align: center;
          overflow: hidden;
          button {
            width: 150px;
            + button {
              margin-top: 10px;
            }
            a {
              color: ${colors.uiWhite};
            }
          }
          *:not(img) {
            z-index: 1;
          }
        `}
      >
        <img
          src={blockBackground}
          alt="Pink cloud-like shapes"
          className={css`
            position: absolute;
            top: -20px;
            left: -70px;
            width: 200%;
            height: 200%;
            z-index: 0;
            opacity: 0.7;
          `}
        />
        <Text type="header" sizing="M" color={colors.uiGraphiteLight}>
          Sorry, an invitation is required to join a private club.
        </Text>
        <div>
          <Button small>
            <Link
              to={marketingRoutes.home}
              className={css`
                padding: 0 20px;
              `}
            >
              Find a club
            </Link>
          </Button>
          <Button small>
            <Link
              to={marketingRoutes.home}
              className={css`
                padding: 0 20px;
              `}
            >
              Buy an eBook
            </Link>
          </Button>
        </div>
      </FlexBox>
    </FlexBox>
  )
}

export default ClubDetailPrivateClubBlock
